

















































































































import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import {
  CANT_SEE_SECTION_MSG,
  CompanyID,
    formatDate,
    formatList,
    getCurrentTimestamp,
    getIndexFromList,
    getPropertyFromList,
    ID, matchedIndexIdInArray, OptionalCompany, parameterValueValidation, PRIVILEGE_KEYS, PRIVILEGE_TYPES, sortObjectByPropertyName,
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import moment, { invalid } from 'moment';
import { Company, SuscriptionsList, Template, UsersEmails, Suscription, Vehicle, ParameterValue } from '../../../features/core/models/';
import { SettingsService } from '../api/SettingsService';
import { NormsServices } from '../../norms/api/NormsServices';
import { ecuIsNotScannerMsg, ecuIsScanner, ecuScanner } from '../../norms/utils';

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        SectionTitle,
        MultipleSelect,
        Input
    }
})
export default class SetParameterValue extends Mixins(
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
) {
    @Prop({default: false}) visible: boolean;
    @Prop({default: []}) vehicleIdToEdit: string[];
    @Prop({default: null}) parameterValueToEdit: ParameterValue;
    @Prop({ default: () => {}}) vehicleProperties: object;
    defaultModalTitle: string = 'Set Parameter Value';
    modalTitle: string = this.defaultModalTitle;
    submitDefaultTitle: string = 'Guardar';
    variableNotFoundMessage: string = 'La variable seleccionada no existe en la lista de disponibles'
    submitName: string = this.submitDefaultTitle;
    errorMsg: string = '';
    variableSelected: object | null = null;
    variableSelectedRv: boolean = false;
    disableVehicleSelection: boolean = true;
    showVariableNotFound: boolean = false;
    preselectedVehicles: Array<Vehicle> = [];
    parameterValue: number | null = null;
    variableType: string | number;

    get getInputLabel(){
        let base = 'Valor';
        if(this.variableSelected !== null){
            base += ' (' + this.$_getNormsProperties['all_slot_types'][this.variableSelected['type_of_data']] + ')'
        }
        return base
    }

    get validateValue(){
        if(this.variableSelected !== null){
            if(
                typeof this.parameterValue === 'string' &&
                this.variableSelected['type_of_data'] > 2
            ){
               let paramValue: string = this.parameterValue;
               this.updateParameterValue(Number(paramValue.trim()))
            }
            return parameterValueValidation(this.variableSelected['type_of_data'], this.parameterValue);
        }
        return false
    }

    updateVariableType(variable){
        let variableType = variable['type_of_data'];
        let parameterValueTypes = this.$_getNormsProperties['all_slot_types'];
        // console.log("parameterValueTypes", parameterValueTypes);
        // console.log("variable actual", variable);
        // console.log("variableType variable actual", variableType);
    }

    selectVehicle(vehicle: Vehicle){
        if(vehicle){
            this.preselectedVehicles.push(vehicle);
        }
    }
    removeVehicle(vehicle: Company){
       this.preselectedVehicles = this.preselectedVehicles.filter(item => item.id !== vehicle.id);
    }

    updateVariableSelected(variable){
        this.updateParameterValue(null);
        this.updateVariableType(variable);
        if(variable !== null && variable['type_of_data']){
            variable['type_of_data'] = Number(variable['type_of_data']);
        }
        this.variableSelected = variable;
    }
    updateVariableSelectedRv(text){
        this.variableSelectedRv = text;
    }
    setModalTitle(text){
        this.modalTitle = text;
    }

    setSubmitButtonName(text){
        this.submitName = text;
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }

    needToUpdateModalCheckRecipients: boolean = false;
    pendingAvailableVariables: boolean = false;
    recipientsWithUpdatedCompanies: any = [];
    availableVariables: Array<object> = [];

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
        this.parameterValueSetted(response, this.parameterValue);
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    submitAction(){
        let configuration:ParameterValue = this.getData();
        this.pendingLoadingDialog('Seteando parameter value...')

        SettingsService.setVehicleParameterValue(
            configuration
        ).then((res) => {
            this.handleSuccessAction(res);
            this.closeModal();
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudo setear el parameter value');
        })
    }


    getData():ParameterValue{
        if(
            this.parameterValue !== null && 
           this.variableSelected !== null && this.variableSelected['type_of_data'] > 2
        )
        {
            this.parameterValue = Number(this.parameterValue);
        }
        return {
            "variable_id": this.variableSelected !== null ? this.variableSelected['variable_id'] : -1,
            "vehicle_id": Number(this.vehicleIdToEdit[0]),
            "value": this.parameterValue == null ? 0 : this.parameterValue
        }
    }


    get formIsValid() {
        this.setErrorForm('');
        if(this.variableSelected == null){
            this.setErrorForm('Debe seleccionar una variable')
            return false
        }
        if(!ecuIsScanner(this.variableSelected['ecu'])){
            this.setErrorForm(ecuIsNotScannerMsg)
            return false
        }
        if(this.parameterValue == null){
            this.setErrorForm('No ingreso el valor')
            return false
        }
        if(this.validateValue !== true){
            this.setErrorForm('El valor no es valido')
            return false
        }
        return true
    }

    @Emit()
    closeModal() {}

    @Emit()
    parameterValueSetted(response, newValue) {}

    updateParameterValue(value){
        if(value === ''){
            value = null;
        }
        this.parameterValue = value;
    }

    created(){}

    mounted() {
        this.$nextTick(() => {
           this.loadParameterValueForEditing();
           this.preselectVehicles();
           this.getAllVariables();
        });
    }

    preselectVariableForEditing(){
         if(this.parameterValueToEdit !== null){
            let indexVariableInAvailablesOnes = getIndexFromList(this.availableVariables, 'variable_id', this.parameterValueToEdit.variable_id);
            if(indexVariableInAvailablesOnes !== -1){
                this.variableSelected = this.availableVariables[indexVariableInAvailablesOnes]
            }else{
                this.showAlertVariableNotFound();
            }
         }
         this.loadParameterValueForEditing();
    }

    showAlertVariableNotFound(){
         this.showVariableNotFound = true;
        setTimeout(() => {
            this.showVariableNotFound = false;
        }, 2500);
    }

    loadParameterValueForEditing(){
        if(this.parameterValueToEdit !== null){
            this.updateParameterValue(this.parameterValueToEdit.value);
        }
    }

    async getAllVariables(){
        /* 
            La lista de variables es la suma de las disponibles y las activas para el vehiculo
            son 2 webservices 
        */
       let self = this;
        this.pendingAvailableVariables = true;
        this.availableVariables = [];

        let availableVariables = await NormsServices.getParameterVersionList(this.vehicleIdToEdit[0])
            .then(res => res)
            .catch(error => {
                this.pendingAvailableVariables = false;
                return false;
            });
        if (availableVariables) {
            this.addVariablesToMainList(availableVariables);
        }

        let activeVariables = await NormsServices.getVariableConfigurationList(this.vehicleIdToEdit[0])
            .then(res => res)
            .catch(error => {
                this.pendingAvailableVariables = false;
                this.preselectVariableForEditing();
                return false;
            });
            if (activeVariables) {
                this.pendingAvailableVariables = false;
                this.addVariablesToMainList(activeVariables);
                this.preselectVariableForEditing();
            }
    }

    addVariablesToMainList(variablesList){
        this.availableVariables = [
            ...this.availableVariables,
            ...variablesList
        ]
        if(this.availableVariables.length > 0){
           this.availableVariables = this.availableVariables.sort(sortObjectByPropertyName('variable'))
        }
    }

    addVehicleDescriptionToModalTitle(vehicle: Vehicle){
        this.modalTitle += ' <b>' + vehicle.vin + ' - ' + vehicle.description + '</b>';
    }

    preselectVehicles(){
        let allVehicles = this.$_getVehiclesFromSelectedCompanySorted;
        let indexInVehiclesList = allVehicles.findIndex(vehicle => vehicle['id'] === Number(this.vehicleIdToEdit));
        if(indexInVehiclesList !== -1){
            this.selectVehicle(allVehicles[indexInVehiclesList]);
            this.addVehicleDescriptionToModalTitle(allVehicles[indexInVehiclesList]);
        }
    }
}
